import Vue from 'vue'
import VueI18n from 'vue-i18n'

import VueRouter from 'vue-router';
import BootstrapVue from "bootstrap-vue"
import VueApexCharts from 'vue-apexcharts'

import { createPinia } from "pinia";

Vue.use(createPinia());

Vue.use(VueI18n);
Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(VueApexCharts);

import './vue-filters.js'

import App from './App.vue'

import User from './components/User.vue'
import TrackerPublic from './components/TrackerPublic.vue'
import Login from './components/Login.vue'

import Zones from './components/Zones.vue'
import Places from './components/Places.vue'
import Devices from './components/Devices.vue'
import ImportPlaces from './components/ImportPlaces'
import ModifyDevices from "@/components/ModifyDevices";

import Tags from './components/Tags'
import Contacts from './components/Contacts'
import Administration from "./components/Administration"
import AddTracker from "./components/AddTracker"
import DataExport from "./components/DataExport"
import Dashboard from './components/Dashboard'
import Invoices from "./components/Invoices"

import TrackerTemperature from "@/components/TrackerTemperature";

import ShowDevices from "./components/ShowDevices"
import WebBLE from './components/WebBLE'
import Push from './components/Push'

import ErrorServer from './components/Error'
import Error404 from './components/Error404'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

import 'bootstrap-vue/dist/bootstrap-vue.css'
import $ from 'jquery';
window.$ = window.jQuery = $;


import "./assets/scss/style.scss"


import store from './store/store'
import { HTTP } from "./http-constants";

Vue.config.productionTip = false
Vue.config.delimiters = ['${', '}'];

import moment from 'moment'

function loadLocaleMessages() {
  const locales = require.context('./lang', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

let locale = navigator.language.substring(0, 2);
moment.locale(locale);

const i18n = new VueI18n({
  fallbackLocale: 'en',
  locale: locale,
  messages: loadLocaleMessages()
})


const router = new VueRouter({
  mode: 'history',
  routes: [
    { path: '/', redirect: { name: 'devices' }, meta: { title: 'Invoxia - ' + i18n.t('devices') } },
    {
      path: '/user/', component: User,
      children: [
        { path: '', redirect: { name: 'devices' }, meta: { title: 'Invoxia - ' + i18n.t('devices') } },
        { path: 'zones', name: 'zones', component: Zones, meta: { title: 'Invoxia - ' + i18n.t('Alerts') } },
        { path: 'places/import/', name: 'import_places', component: ImportPlaces, meta: { title: 'Invoxia - ' + i18n.t('import_places') } },
        { path: 'places', name: 'places', component: Places, meta: { title: 'Invoxia - ' + i18n.t('Places') } },
        { path: 'devices/modify/', name: 'devices_modify', component: ModifyDevices, meta: { title: 'Invoxia - ' + i18n.t('devices') } },
        { path: 'devices', name: 'devices', component: Devices, meta: { title: 'Invoxia - ' + i18n.t('devices') } },
        { path: 'tags', name: 'tags', component: Tags, meta: { title: 'Invoxia - ' + i18n.t('tags') } },
        { path: 'contacts', name: 'contacts', component: Contacts, meta: { title: 'Invoxia - ' + i18n.t('contacts') } },
        { path: 'add_tracker', name: 'add_tracker', component: AddTracker, meta: { title: 'Invoxia - ' + i18n.t('add_tracker') } },
        { path: 'administration', name: 'administration', component: Administration, meta: { title: 'Invoxia - ' + i18n.t('administration') } },
        { path: 'data_export', name: 'data_export', component: DataExport, meta: { title: 'Invoxia - ' + i18n.t('export') } },
        { path: 'dashboard', name: 'dashboard', component: Dashboard, meta: { title: 'Invoxia - ' + i18n.t('dashboard') } },
        { path: 'invoices', name: 'invoices', component: Invoices, meta: { title: 'Invoxia - ' + i18n.t('invoices') } },
      ]
    },
    { path: '/login', component: Login, meta: { title: 'Invoxia - ' + i18n.t('login_signin') } },
    { path: '/devices', component: ShowDevices, meta: { title: 'Invoxia - ' + i18n.t('devices') } },
    { path: '/devices/temperature/', component: TrackerTemperature, meta: { title: 'Temperature' }},
    { path: '/tracker_pub.html', name: 'TrackerPublic', component: TrackerPublic, meta: { title: 'Invoxia - ' + i18n.t('tracker_public') } },
    { path: '/webble', name: 'webble', component: WebBLE, meta: { title: 'Invoxia - WebBLE' } },
    { path: '/push', name: "Push", component: Push, meta: { title: "Invoxia - Push"}},
    { path: '/error', name: 'error', component: ErrorServer, meta: { title: 'Invoxia - ' + i18n.t('error') } },
    { path: '*', name: '404', component: Error404, meta: { title: 'Invoxia - ' + i18n.t('error_404') } }
  ]
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()
});

export var vm = new Vue({
  render: h => h(App),
  i18n,
  router,
  store,
  created: function () {
    HTTP.defaults.headers.common['Authorization'] = "Bearer " + this.$store.state.jwt
  }
}).$mount('#app')

window.app = vm
